import { useContext } from "react";

import { LoadingContext } from "@shared/context";

const useLoadingData = () => useContext(LoadingContext);

export { useLoadingData };
